module.exports = __webpack_public_path__ + "img/block-375.f69cd5f3.jpg";